export default "__VITE_ASSET__Bf0N$ksm__"